import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

import DescriptionList from '@anwb/poncho/components/description-list';
import Panel from '@anwb/poncho/components/panel';
import Typography from '@anwb/poncho/components/typography';

import { ErrorType } from '../constants';
import { mapUserInformationToDescriptionListItems } from '../utils/mapUserInformationToDescriptionListItems';
import { useLoggedInUserInformation } from '../utils/useLoggedInUserInformation';

import { MissingPersonalDataForm } from './MissingPersonalDataForm';
import { Remarks } from './Remarks';

export const LoggedInUserInformation = ({
	setError,
	formHook,
	setLoadingLoggedInUserInfo,
}: {
	setError: React.Dispatch<ErrorType>;
	formHook: UseFormReturn;
	setLoadingLoggedInUserInfo: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
	const { plCustomerData, loading, error } = useLoggedInUserInformation();

	useEffect(() => {
		if (plCustomerData?.isMember === false) {
			setError('RELATION_NO_MEMBER_NOTIFICATION');
		}
	}, [plCustomerData?.isMember, setError]);

	useEffect(() => {
		if (error) {
			setError('RETRIEVING_DATA_LOGGED_IN_ERROR');
		}
	}, [error, setError]);

	useEffect(() => {
		setLoadingLoggedInUserInfo(loading);
		formHook.reset();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loading]);

	return (
		<>
			<Panel>
				<Panel.Header title="Persoonlijke gegevens" />
				{!loading && !error && plCustomerData && (
					<Panel.Content>
						<DescriptionList items={mapUserInformationToDescriptionListItems(plCustomerData)} />

						<Typography>
							Kloppen deze gegevens niet?{' '}
							<Typography tagName="a" variant="link-text" href="/mijnanwb">
								Wijzig dan je gegevens in Mijn ANWB.
							</Typography>
						</Typography>
					</Panel.Content>
				)}
			</Panel>
			{!loading && !error && plCustomerData && <MissingPersonalDataForm formHook={formHook} />}

			<Remarks />
		</>
	);
};
